<template>
  <component :is="dashboard"/>
</template>

<script>

import AdminDashboard from "@/views/dashboard/AdminDashboard";
import CuratorDashboard from "@/views/dashboard/CuratorDashboard";
import {mapGetters} from "vuex";

export default {
  components: {AdminDashboard, CuratorDashboard},
  data: () => ({

    //open: false,
  }),
  methods: {},
  computed: {
    ...mapGetters('account', ['isAdmin']),
    dashboard() {
      //return 'AdminDashboard' ;
      return this.isAdmin ? 'AdminDashboard' : 'CuratorDashboard';

    },
  }

}
</script>